export const BLOCKQUOTE_BUTTON_DATA_HOOK = 'textBlockStyleButton_Quote';
